module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-snow-fill-c5cb5f01.svg";